module.exports = __webpack_public_path__ + "static/media/kidsartkids_02_A.194a63a4.png";